import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import StatusTable from "./StatusTable";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
}));

export default function SimplePaper(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <StatusTable/>
        </div>
    );
}